"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.contentWidth = void 0;
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var core_1 = require("@material-ui/core");
var translate_1 = __importDefault(require("../../app/localization/translate"));
var TaskPage_1 = __importDefault(require("./TaskPage"));
var components_1 = require("../../youwell-common/components");
var store_1 = require("../../app/store");
var urls_1 = __importDefault(require("../../app/urls"));
var ProgramPage_1 = __importDefault(require("./ProgramPage"));
var components_2 = require("../../common/components");
var theme_1 = require("../../app/style/theme");
var appSetup_1 = require("../../app/appSetup");
var Login_1 = __importDefault(require("../outside/components/Login"));
var ProgramSelect_1 = __importDefault(require("./ProgramSelect"));
exports.contentWidth = 1080;
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a, _b, _c;
    return (0, core_1.createStyles)({
        root: {
            background: theme.palette.background.default,
            display: 'flex',
            justifyContent: 'center',
        },
        header: (_a = {
                position: 'fixed',
                width: '100vw',
                paddingRight: theme_1.scrollerWidth,
                height: theme_1.headerHeight,
                background: theme.palette.primary.main,
                display: 'flex',
                justifyContent: 'center',
                zIndex: 100
            },
            _a[theme.breakpoints.down('xs')] = {
                paddingRight: 0,
            },
            _a['@media print'] = {
                display: 'none',
            },
            _a),
        headerContent: (_b = {
                width: '100%',
                maxWidth: exports.contentWidth
            },
            _b[theme.breakpoints.up('lg')] = {
                width: exports.contentWidth - theme_1.scrollerWidth,
            },
            _b),
        content: (_c = {
                marginTop: theme_1.headerHeight,
                width: '100%',
                minHeight: '100vh',
                maxWidth: exports.contentWidth
            },
            // background: theme.palette.common.white,
            // boxShadow: theme.shadows[1],
            _c[theme.breakpoints.up('lg')] = {
                width: exports.contentWidth - theme_1.scrollerWidth,
            },
            _c[theme.breakpoints.down('xs')] = {
                boxShadow: 'none',
                minHeight: 0,
            },
            _c['@media print'] = {
                marginTop: 0,
                minHeight: 0,
            },
            _c),
        mainContent: {},
    });
});
var Index = function () {
    var classes = useStyles();
    var translate = (0, translate_1.default)();
    var pageNotFound = (0, store_1.useYouwellSelector)(function (state) { return state.pageSettings.pageNotFound; });
    var _a = React.useState(false), showLoginBox = _a[0], setShowLoginBox = _a[1];
    return (React.createElement("div", { className: classes.root },
        React.createElement(components_1.ErrorBoundary, { id: "OutsideLayout_Header" },
            React.createElement("div", { className: classes.header },
                React.createElement("div", { className: classes.headerContent },
                    React.createElement(components_2.Header, { hideMenu: true, hideLinks: true, defaultItems: [appSetup_1.headerItems.title, appSetup_1.headerItems.flex, appSetup_1.headerItems.customActions], headerActions: [{ text: translate('login.login'), action: function () { return setShowLoginBox(true); } }] })))),
        React.createElement("div", { className: classes.content },
            React.createElement(components_1.ErrorBoundary, { id: "OutsideLayout_Content" }, pageNotFound ? (React.createElement(components_1.PageNotFound, null)) : (React.createElement(React.Fragment, null,
                React.createElement("div", { className: classes.mainContent },
                    React.createElement(react_router_dom_1.Switch, null,
                        React.createElement(react_router_dom_1.Route, { path: "".concat(urls_1.default.outsideProgram.task, "/:programId/:moduleIndex/:taskIndex"), component: TaskPage_1.default }),
                        React.createElement(react_router_dom_1.Route, { path: "".concat(urls_1.default.outsideProgram.program, "/:programId?"), component: ProgramPage_1.default }),
                        React.createElement(react_router_dom_1.Route, { path: urls_1.default.outsideProgram.programSelect, component: ProgramSelect_1.default }),
                        React.createElement(react_router_dom_1.Route, { component: ProgramSelect_1.default }))))))),
        React.createElement(components_1.ErrorBoundary, { id: "OutsideLayout_Login" },
            React.createElement(components_2.PortalModal, { open: showLoginBox, onClose: function () { return setShowLoginBox(false); }, heading: translate('login.login') },
                React.createElement(Login_1.default, null)))));
};
exports.default = Index;
